module.exports = __webpack_public_path__ + "img/体系模型select.77733090.svg";